import AssignmentType from './type';
import './styles.css';

export default function AssignmentsList({
  user,
  games,
  nonTournamentGames,
  tournamentGames,
  tournaments,
  onTournamentDeletionConfirm,
  onGameDeletionConfirm,
  sessions = [],
  bestScores = {}
}) {
  if (!games?.length && !tournaments?.length) {
    return null;
  }

  const customOrder = [
    'Review Sessions',
    'Account Classification',
    'Normal Balance',
    'The Principles',
    'Balanced Equation',
  ];

  const groupedAssignments = {};

  const reviewSessions = tournaments?.length > 0 ? tournaments : tournamentGames;
  if (reviewSessions && reviewSessions.length > 0) {
    groupedAssignments['Review Sessions'] = reviewSessions;
  }

  if (nonTournamentGames && nonTournamentGames.length > 0) {
    nonTournamentGames.forEach(game => {
      if (!groupedAssignments[game.game_type]) {
        groupedAssignments[game.game_type] = [];
      }
      groupedAssignments[game.game_type].push(game);
    });
  }

  const sortedAssignmentTypes = Object.keys(groupedAssignments).sort((a, b) => 
    customOrder.indexOf(a) - customOrder.indexOf(b)
  );

  return (
    <div className="assignments-list">
      {sortedAssignmentTypes.map((assignmentType, index) => (
        <AssignmentType
          key={index}
          user={user}
          assignmentType={assignmentType}
          assignments={groupedAssignments[assignmentType]}
          onTournamentDeletionConfirm={onTournamentDeletionConfirm}
          onGameDeletionConfirm={onGameDeletionConfirm}
          sessions={sessions}
          games={games}
          bestScores={bestScores[assignmentType]}
        />
      ))}
    </div>
  );
}
